export const API = "https://iifabackend.soof.uz";
export const ADMIN_URL = "http://localhost:3001";
export const MAIN_URL_LOCAL = 'http://192.168.100.112:8001';


export function formatNumber(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}
